import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import NtxTable from '@components/DataTable/NtxTable';
import Loading from '@components/Shared/Loader/Loading';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from './DynamicFilter3';

// const Index = () => {
//   const { t } = useTranslation();
//   const Navigate = useNavigate();

//   // حالة التحكم في عرض الـ Offcanvas
//   const [showFilters, setShowFilters] = useState(false);

//   const dispatch = useAppDispatch();
//   const { data, loading, error } = useAppSelector(state => state.dynamicTable);

//   useEffect(() => {
//     dispatch(setEndpoint('Inv/GetMaterialTransactionsPaged'));
//     dispatch(getPagedData());
//   }, [dispatch]);

//   const columns = [
//     { title: t('TransType'), key: 'type' },
//     { title: t('TransactionDate'), key: 'date' },
//     { title: t('Code'), key: 'num' },
//     { title: t('ReferenceNumber'), key: 'ref' },
//     { title: t(''), key: 'action', className: 'text-end', sortable: false }
//   ];

//   const tableData = data?.map((item: any) => {
//     return {
//       num: item.code,
//       date: item.transactionDate?.split('T')[0],
//       type: item.transactionTypeName,
//       ref: item.referenceCode || '---------------',
//       action: (
//         <button
//           type='button'
//           className='btn btn-sm btn-outline-theme me-1'
//           onClick={() => Navigate(`${item.id}/UpdateInvIssue`)}
//         >
//           <i className='far fa-lg   fa-fw fa-edit'></i>
//         </button>
//       )
//     };
//   });

//   const fields: any[] = [
//     { name: 'transactionDate', label: 'Transaction Date', type: 'date' },
//     { name: 'amount', label: 'Amount', type: 'number' },
//     { name: 'description', label: 'Description', type: 'string' },
//     { name: 'isActive', label: 'Active', type: 'boolean' }
//   ];

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: t('Home'),
//              link: ':moduleHome'
//             },
//             {
//               name: t('الحركات المخزنية'),
//               link: null
//             }
//           ]}
//           PageName={t('الحركات المخزنية')}
//         />
//              <button
//           className='btn btn-outline-primary ms-auto'
//           onClick={() => setShowFilters(true)}
//         >
//           <i className='bi bi-funnel me-1'></i>
//           فلاتر البحث
//         </button>
//       </div>

//       <div className={`offcanvas offcanvas-end ${showFilters ? 'show' : ''}`} style={{ visibility: showFilters ? 'visible' : 'hidden' }}>
//         <div className='offcanvas-header w-100'>
//           <h5 className='offcanvas-title w-100'>
//             <i className='bi bi-funnel me-2'></i>
//             فلاتر البحث والترتيب
//           </h5>
//           <button
//             type='button'
//             className='btn-close'
//             onClick={() => setShowFilters(false)}
//           ></button>
//         </div>
//         <div className='offcanvas-body p-0'>
//           <DynamicFilter
//             fields={fields}
//             // onClose={() => setShowFilters(false)}
//           />
//         </div>
//       </div>

//       {/* Backdrop للـ Offcanvas */}
//       {showFilters && (
//         <div
//           className='offcanvas-backdrop fade show'
//           onClick={() => setShowFilters(false)}
//         ></div>
//       )}

//       {/* <DynamicFilter fields={fields} /> */}
//       <div className=''>
//         <Card style={{ minHeight: '60vh' }}>
//           <Loading loading={loading} error={error} Type='Dots'>
//             <CardBody>
//               <NtxTable
//                 data={tableData || []}
//                 columns={columns}
//                 dataPerPage={10}
//                 theadClass=''
//                 tableClass='table text-nowrap table-hover '
//               />
//             </CardBody>
//           </Loading>
//         </Card>
//       </div>

//       <style>{`
//         .offcanvas-backdrop.show {
//     opacity: 0.0;
// }
//         `}</style>
//     </>
//   );
// };

const Index = () => {
  const { t } = useTranslation();
  const Navigate = useNavigate();

  // حالة التحكم في عرض الـ Offcanvas
  const [showFilters, setShowFilters] = useState(false);

  const dispatch = useAppDispatch();
  const { data, loading, error } = useAppSelector(state => state.dynamicTable);

  useEffect(() => {
    dispatch(setEndpoint('Inv/GetMaterialTransactionsPaged'));
    dispatch(getPagedData());
  }, [dispatch]);

  const columns = [
    { title: t('TransType'), key: 'type' },
    { title: t('TransactionDate'), key: 'date' },
    { title: t('Code'), key: 'num' },
    { title: t('ReferenceNumber'), key: 'ref' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = data?.map((item: any) => {
    return {
      num: item.code,
      date: item.transactionDate?.split('T')[0],
      type: item.transactionTypeName,
      ref: item.referenceCode || '---------------',
      action: (
        <button
          type='button'
          className='btn btn-sm btn-outline-theme me-1'
          onClick={() => Navigate(`${item.id}/UpdateInvIssue`)}
        >
          <i className='far fa-lg fa-fw fa-edit'></i>
        </button>
      )
    };
  });

  const fields: any[] = [
    { name: 'transactionDate', label: 'Transaction Date', type: 'date' },
    { name: 'amount', label: 'Amount', type: 'number' },
    { name: 'description', label: 'Description', type: 'string' },
    { name: 'isActive', label: 'Active', type: 'boolean' }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: t('Home'),
             link: ':moduleHome'
            },
            {
              name: t('الحركات المخزنية'),
              link: null
            }
          ]}
          PageName={t('الحركات المخزنية')}
        />
        <button className='btn btn-outline-primary ms-auto' onClick={() => setShowFilters(true)}>
          <i className='bi bi-funnel me-1'></i>
          فلاتر البحث
        </button>
      </div>

      <DynamicFilter fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      <div className=''>
        <Card style={{ minHeight: '60vh' }}>
          <Loading loading={loading} error={error} Type='Dots'>
            <CardBody>
              <NtxTable
                data={tableData || []}
                columns={columns}
                dataPerPage={10}
                theadClass=''
                tableClass='table text-nowrap table-hover '
              />
            </CardBody>
          </Loading>
        </Card>
      </div>
    </>
  );
};

export default Index;
